
import { ContractTypeModal } from "@/components/contract-types/ContractTypeModal";
import { CategoryModal } from "@/components/categories/CategoryModal";
import { ContactModal } from "@/components/contacts/ContactModal";
import { CurrencyModal } from "@/components/currencies/CurrencyModal";

interface ContractFormModalsProps {
  contractTypeModalOpen: boolean;
  setContractTypeModalOpen: (open: boolean) => void;
  categoryModalOpen: boolean;
  setCategoryModalOpen: (open: boolean) => void;
  contactModalOpen: boolean;
  setContactModalOpen: (open: boolean) => void;
  currencyModalOpen: boolean;
  setCurrencyModalOpen: (open: boolean) => void;
  showUnsavedChangesDialog: boolean;
  setShowUnsavedChangesDialog: (open: boolean) => void;
  onConfirmNavigation: () => void;
  onCancelNavigation: () => void;
  onContractTypeCreated: (contractType: any) => any;
  onCategoryCreated: (category: any) => any;
  onContactCreated: (contact: any) => any;
  onCurrencyCreated: (currency: any) => any;
}

export function ContractFormModals({
  contractTypeModalOpen,
  setContractTypeModalOpen,
  categoryModalOpen,
  setCategoryModalOpen,
  contactModalOpen,
  setContactModalOpen,
  currencyModalOpen,
  setCurrencyModalOpen,
  onContractTypeCreated,
  onCategoryCreated,
  onContactCreated,
  onCurrencyCreated
}: ContractFormModalsProps) {
  return (
    <>
      <ContractTypeModal 
        open={contractTypeModalOpen} 
        onOpenChange={setContractTypeModalOpen}
        onSuccess={onContractTypeCreated}
      />
      <CategoryModal
        open={categoryModalOpen}
        onOpenChange={setCategoryModalOpen}
        onSuccess={onCategoryCreated}
      />
      <ContactModal
        open={contactModalOpen}
        onOpenChange={setContactModalOpen}
        onSuccess={onContactCreated}
      />
      <CurrencyModal
        open={currencyModalOpen}
        onOpenChange={setCurrencyModalOpen}
        onSuccess={onCurrencyCreated}
      />
    </>
  );
}
